import type { App } from 'vue'
import amount from './amount'
import tooltip from './tooltip'
import socket from './socket'
import resizeRight from './resize-right'
import maskSensitive from './mask-sensitive'
import smartName from './smartName'

export default {
  install(app: App) {
    app.directive('amount', amount)
    app.directive('tooltip', tooltip)
    app.directive('socket', socket)
    app.directive('resize-right', resizeRight)
    app.directive('mask', maskSensitive)
    app.directive('smart-name', smartName)
  },
}
